import React from 'react';

const TopLeft2Shape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="176" 
      height="132" 
      viewBox="0 0 176 132" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
    <path 
      d="M0.498869 129.625C9.47289 130.142 161.442 54.7231 173.374 -78.1249" 
      stroke="#9DBCC5" 
      stroke-width="4.5"
    />
  </svg>
  );
};

export default TopLeft2Shape;


